var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"root",staticClass:"form-control form-control-lg",attrs:{"placeholder":"MM/DD/YYYY","disabled":_vm.disabled,"required":_vm.required},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }